import { API_URL, headers, accessToken } from "../constants/config";
import axios from "../utils/axios";
let data_version = localStorage.getItem("data_version");

export const getInitData = async () => {
  let headers = {};
  if(window.location.hostname === 'localhost'){ //for logged user view
    headers = { headers : {"Access-Token": `${accessToken}`}};
  }
  return fetch(API_URL + "api/front_end/init_data?v="+data_version,)
    .then((res) => res.json())
    .then((res) => res);
};

export const getSecondaryData = async () => {
  return fetch(API_URL + "api/front_end/secondary_data?v="+data_version)
    .then((res) => res.json())
    .then((res) => res);
};

export const getBulkConfigs = async () => {
  return fetch(API_URL + "api/front_end/bulk_configs?v="+data_version)
    .then((res) => res.json())
    .then((res) => res);
};

export const getProductsData = () => {
  return fetch(API_URL + "/testdata/productsdata.json?v="+data_version)
    .then((res) => res.json())
    .then((res) => {
      let response = [];
      response.data = res
      return response;
    });
};

export const getHomePage = async () => {
  return fetch(API_URL + "api/front_end/home_page.json?v="+data_version)
    .then((res) => res.json())
    .then((res) => {
      let response = [];
      response.data = res
      return response;
    });
};

export const getRouteApi = async () => {

  return fetch(API_URL + "api/front_end/getRoute.json?v="+data_version)
    .then((res) => res.json())
    .then((res) => {
      let response = [];
      response.data = res
      return response;
    });
};

export const getAllCourses = async () => {
  return fetch(API_URL + "api/front_end/all_courses?v="+data_version)
    .then((res) => res.json())
    .then((res) => res.data);
};

export const getAllEnquiryFields = async () => {
  return fetch(API_URL + "api/front_end/all_enquiry_fields?v="+data_version)
    .then((res) => res.json())
    .then((res) => res.data);
}

/* After login */
export const getInitialData = () => {
  return axios.request({
    url: "/testdata/initialdata.json",
    method: "get",
  });
};